import React from 'react'
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";
import Head from "next/head";
import Link from 'next/link';
const About_TNPSC = () => {
    const addJsonLd = () => {
        return {
          __html: `
           {"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.shankariasacademy.com/tnpsc-admissions/","url":"https://www.shankariasacademy.com/tnpsc-admissions/","name":"TNPSC Syllabus 2023 | Examination Pattern and Syllabus | Shankar IAS Academy","isPartOf":{"@id":"https://www.shankariasacademy.com/#website"},"datePublished":"2021-12-28T06:07:28+00:00","dateModified":"2023-02-22T09:23:17+00:00","description":"IAS TNPSC Syllabus | About TNPSC - IAS Civil Services Exam is conducted by TNPSC. Know Syllabus, Subjects, Book List, Optional Subject and Mock Test Series about TNPSC","breadcrumb":{"@id":"https://www.shankariasacademy.com/tnpsc-admissions/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.shankariasacademy.com/tnpsc-admissions/"]}]},{"@type":"BreadcrumbList","@id":"https://www.shankariasacademy.com/tnpsc-admissions/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://www.shankariasacademy.com/"},{"@type":"ListItem","position":2,"name":"Admission TNPSC About"}]},{"@type":"WebSite","@id":"https://www.shankariasacademy.com/#website","url":"https://www.shankariasacademy.com/","name":"Shankar IAS Academy","description":"Best IAS Coaching in India","publisher":{"@id":"https://www.shankariasacademy.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.shankariasacademy.com/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"Organization","@id":"https://www.shankariasacademy.com/#organization","name":"Shankar IAS Academy","url":"https://www.shankariasacademy.com/","logo":{"@type":"ImageObject","inLanguage":"en-US","@id":"https://www.shankariasacademy.com/#/schema/logo/image/","url":"https://www.shankariasacademy.com/wp-content/uploads/2022/07/shankariasacademy.jpg","contentUrl":"https://www.shankariasacademy.com/wp-content/uploads/2022/07/shankariasacademy.jpg","width":361,"height":79,"caption":"Shankar IAS Academy"},"image":{"@id":"https://www.shankariasacademy.com/#/schema/logo/image/"},"sameAs":["https://www.youtube.com/c/ShankarIASAcademyVideos","https://www.instagram.com/shankariasacademy/","https://www.facebook.com/shankariasacademy","https://twitter.com/shankarias"]}]}
          `
        }
      }
      const tnpsclist4 =[
        {contlist:"TNPSC Group I Main Examination*"},
        {contlist:"Modern History of India and Indian Culture"},
        {contlist:"General Mental Ability"},
        {contlist:"Role and Impact of Science and Technology in the development of India and Tamil Nadu"}
      ]

      const tnpsclist5 =[
        {contlist:"Indian Polity and emerging political trends across the"},
        {contlist:"world affecting India and Geography of India"},
        {contlist:"Tamil language, Tamil society–its culture and heritage / English language, English language skills"},
        {contlist:"Administration of Union and States with special reference to Tamil Nadu"}
      ]

      const tnpsclist6 =[
        {contlist:"Current events of national and international importance"},
        {contlist:"Current economic trends; Indian economy and impact of global economy on India"},
        {contlist:"Socio-economic issues in India and Tamil Nadu"}
      ]
  return (
    <>
    

      <div className="tab-content">
      <div className="tab-pane" id="centre-4">
                  {/*Syllabus Section Start */}
                    
                  <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2 className={`${styles.sectiontitle}`}>Prelims Syllabus</h2>
                            <p className={`${styles.acheiverrank} mb-0`}>TNPSC Group I, Group II and Group II A Preliminary Examination – Questions will be asked from the following topics*</p>
                            <p className={`${styles.acheiverrank} mb-0`}>General Science | Current events | Geography | History and Culture of India | Indian Polity | Indian Economy | Indian National Movement |
                             Aptitude and Mental Ability</p>
                            <p className={`${styles.acheiverrank} mb-0`}>Language: General Tamil (or) General English (Only for Group II, Group II A).</p>
                            <p className={`${styles.acheiverrank}`}>*For detailed syllabus refer : <span className={`${styles.redunderline} mb-0`}><Link href="/tnpsc-admissions" className={`${styles.redunderlinealink}`}>English Syllabus </Link> <span style={{color:"#141C26"}}>&nbsp;|&nbsp;</span> <Link href="/tnpsc-admissions" className={`${styles.redunderlinealink}`}> Tamil Syllabus</Link></span></p>
                        </div>
                    </div>
                </div>



                <div className="container">
                    <div className="row pt-md-2">
                        <div className="col">
                          <h2 className={`${styles.sectiontitle} mb-1 mb-md-3`}>Mains Syllabus</h2>
                          <p className={`${styles.aboutheading1} mb-1`}>Group I</p>
                          <p className={`${styles.aboutheading2} mb-1`}>PAPER – I / Unit I</p>
                          {tnpsclist4.map((item,index)=>(
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index} >
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                        {item.contlist}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                          ))}

                        <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – II / Unit II and III</p>
                        {tnpsclist5.map((item,index)=>(
                           <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                        {item.contlist}
                                        </p>
                                    </div>
                                </li>
                           </ul> 
                        ))}


                        <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – III / Unit IV and V</p>
                        {tnpsclist6.map((item,index)=>(
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                       {item.contlist}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        ))}

                       </div>
                    </div>
                </div>


                <div className="container">
                    <div className="row">
                        <div className="col">
                          <p className={`${styles.aboutheading1} pt-3 mb-1`}>Group II</p>
                          <p className={`${styles.aboutheading2} mb-1`}>PAPER – I / Unit I</p>

                          <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            TNPSC Group II (Interview Post) Main Examination
                                            </p>
                                        </div>
                                    </li>

                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            Role and Impact of Science and Technology in the development of India and Tamil Nadu
                                            </p>
                                        </div>
                                    </li>

                          </ul>

                          

                        <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – II / Unit II and III</p>
                        <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            Administration of Union and States with special reference to Tamil Nadu
                                            </p>
                                        </div>
                                    </li>

                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            Socio-economic issues in India and Tamil Nadu
                                            </p>
                                        </div>
                                    </li>

                        </ul>


                        <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – III / Unit IV and V</p>
                        <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            Current Issues at National Level
                                            </p>
                                        </div>
                                    </li>

                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            Current Issues at State Level
                                            </p>
                                        </div>
                                    </li>
                        </ul>

                       </div>
                    </div>
                </div>


                    
                    {/*Syllabus Section End */}
     </div>     
</div>
    
    </>
  )
}

export default About_TNPSC;